import React, {ReactNode} from 'react';
import styles from './AdminEditableTextWrapper.module.css'
import {useAppSelector} from "../../../../hooks/redux";
import {getUser} from "../../../../store/selectors/authSelector";
import {EnumRoles} from "../../../../enums/EnumRoles";
import {checkRole} from "../checkRole";

interface IProps {
    children: ReactNode,
    setEditMode: (boolean: boolean) => void

}


const AdminEditableTextWrapper = ({children, setEditMode} : IProps) => {

    const user = useAppSelector(getUser)

    if (user && checkRole([EnumRoles.admin, EnumRoles.moderator], user.role)) {
        return (
            <div className={styles.wrapper} onDoubleClick={() => setEditMode(true)} title={'Кликните два раза лкм, чтобы изменить текст'}>
                {children}
            </div>
        )
    }

    return (
       <>
           {children}
       </>
    );
};

export default AdminEditableTextWrapper;